import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { AuthService } from '../auth/auth.service';
import queries from './graphql/current-user-request';
import { User } from '../interfaces/user';
import { Loader } from '@googlemaps/js-api-loader';

import { BehaviorSubject, firstValueFrom, Observable, Subscription } from 'rxjs';
import {DateTimeService} from "./date-time.service";

@Injectable({
  providedIn: 'root',
})
export class CurrentUserService {
  private _user: User = {};
  private userBehavior: BehaviorSubject<User> = new BehaviorSubject<User>(
    this._user
  );
  public user$: Observable<User> = this.userBehavior.asObservable();
  public querySub: Subscription;
  private _mapsLoaded = false;
  private mapsLoaded = new BehaviorSubject(this._mapsLoaded);
  public mapsLoaded$ = this.mapsLoaded.asObservable();
  constructor(private apollo: Apollo, private auth: AuthService, private dateTime: DateTimeService) {
    this.apollo = apollo;
  }
  getUser(): Observable<User> {
    let query;
    query = this.getCurrentUserWithProfile();
    if (
      query &&
      !this._user.hasOwnProperty('id') &&
      (!this.querySub || this.querySub.closed)
    ) {
      this.querySub = query.valueChanges.subscribe(({ data }) => {
        if(data){
          this._user = data.me;
          this.userBehavior.next(this._user);
          this.initGoogle(data.me);
          this.querySub.unsubscribe();
        }
      });
    }
    return this.user$;
  }
  updateCurrentUserInToken() {
    let userdata = firstValueFrom(this.getCurrentUserWithProfile().valueChanges)
      .then((data: any) => {
        let tokenData = {
          username: data['data']['me']['username'],
          id: data['data']['me']['user_profile']['id'],
          avatar_color: data['data']['me']['user_profile']['avatar_color'],
          bs_history_time_setting:
            data['data']['me']['user_profile']['bs_history_time_setting'],
        };
        this.auth.updateTokenProperty('profile', tokenData);
        this.auth.updateTokenProperty('id', data['data']['me']['id']);
        this.auth.updateTokenProperty('username', tokenData['username']);
      });
  }
  initGoogle(user: User) {
    let loader = new Loader({
      version: 'weekly',
      apiKey: user.mapsApiKey ?? '',
      libraries: ['places'],
    });
    loader.importLibrary('places').then(() => {
      this._mapsLoaded = true;
      this.mapsLoaded.next(this._mapsLoaded);
    });
  }

  getUserTimezone() {
    return this.dateTime.getLocalTimezone();
  }
  private getCurrentUserWithProfile() {
    return this.apollo.watchQuery<any>({
      query: queries.currentUserWithProfile,
    });
  }


}
